<div class="settings-container">
  <cc-panel-with-links [displayTabsPanel]="true">
    <div tabsPanel>
      <cc-panel-with-links-tabs class="mb-4" [panelTabs]="settingTabs"></cc-panel-with-links-tabs>
    </div>
  </cc-panel-with-links>
</div>
